<template>
  <app-panel class="state-channels-panel">
    <paginated-content
      v-model:limit="pageLimit"
      :entities="stateChannels"
      pagination-style="history"
      :total-count="stateChannelsCount"
      @prev-clicked="loadPrevStateChannels"
      @next-clicked="loadNextStateChannels">
      <state-channels-table :state-channels="stateChannels"/>
    </paginated-content>
  </app-panel>
</template>

<script setup>
const { stateChannels, stateChannelsCount } = storeToRefs(useStateChannelsStore())
const { fetchStateChannels, fetchStateChannelsCount } = useStateChannelsStore()

const pageLimit = usePageLimit('state-channels')

watch(pageLimit, () => {
  loadStateChannels()
})

async function loadPrevStateChannels() {
  await fetchStateChannels({ queryParameters: stateChannels.value.prev })
}

async function loadNextStateChannels() {
  await fetchStateChannels({ queryParameters: stateChannels.value.next })
}

async function loadStateChannels() {
  await fetchStateChannels({ limit: pageLimit.value })
}

fetchStateChannelsCount()

if (import.meta.client) {
  loadStateChannels()
}
</script>
